/* eslint-disable */
// import libs
import { style } from '@material-ui/system';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import { notification } from 'antd';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import store from 'state/appStore';

// import custom components
import StarMarkedIcon from 'static/images/icons/star-marked.svg';
import StarUnmarkedIcon from 'static/images/icons/star-unmarked.svg';
import EcgLoader from 'legacy/containers/EcgLoader';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import CustomTableComponent from '../Common/Table/CustomTableComponent';
import TableHeader from '../Common/Table/TableHeader';
import FormattedDate from '../Common/FormattedDate';

// import constants & utility
import { AlertBoldTextCell, AlertHighlightCell } from '../Common/Table/Utilities/CellStyle';
import { ACUITY_MAP } from '../Common/Table/Constants/Constants';
import { CONDITION_COMPARE_TYPE } from '../Common/Table/Constants/Constants';
import { printTechIntrString } from '../../pages/Annotation/utils/TechIntrParser';
import {
  setInitialKardiaRxCCTEcgTableData,
  getKardiaRxCCTEcgHistory,
  updatedSelectedRxRecording,
  kardiaRxCctResendEosReport,
  getCCTEosEventsHistory,
  kardiaRxCctCompletedCheckbox,
  getEosReportStatus,
} from '../../state/KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryActions';

import { submitStarStatusUpdate } from "../../../legacy/containers/ApiUrls";
// import css
import styles from './CCTPatientHistory.css';
import AlertModal from "../Common/AlertModal";
import history from '../../../legacy/containers/History';
import ROUTE_PATHS from '../../../routes/routePaths';
import FullWidthECGPreview from '../../pages/Annotation/components/FullECGPreview';
import NoEKGPreview from '../../../legacy/components/NoEKGPreview';
import EKGPreview from '../../../legacy/components/EKGPreview';
import HeartIcon from 'static/images/icons/heart.svg';
import SixLeadIcon from 'static/images/six_lead_badge.svg';

import { eosReportHelper } from './util';

const eventName = {
  checkedCompletedReview : 'checked_eos_completed_review',
  uncheckedCompletedReview: 'unchecked_eos_completed_review',
  requestedReportRefresh: 'requested_eos_report_refresh'
}

// Tooltip Style
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    border: '1px solid black'
  },
}))(Tooltip);


const CheckboxCompleted = withStyles((theme) => ({
  root: {
    // '&$checked': {
    //   color: "#067f6f",
    // },
  },
  checked: {},
}))((props) => <Checkbox  color="default" {...props} />);

// Alert Modal Style 
const ALERT_STYLE = {
  width: '154px',
  height: '254px',
}
const ALERT_TEXT = "Only three Highlight Strip can be selected"

const todayDate = moment()

const CCTPatientHistory = props => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [checked, setChecked] = React.useState(true);
  const dispatch = useDispatch();
  const me = useSelector(state => state.app.dataSources.me);
  const recordingInfo = useSelector(state => state.annotator.recordingInfo);


  useEffect(() => {
    props.getKardiaRxCCTEcgHistory(props.match.params);
    props.getCCTEosEventsHistory(props.match.params);
    props.getEosReportStatus(props.match.params)
  }, []);

  // Row clicked
  const clickedRow = rowData => { 
    history.push(`${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/${rowData.recordingId}/${props.match.params.idtf_connection_id}`);
  };
  // filter change function
  const filterChange = () => { };

  const handleHighlightStrip = (e, record) => {
    // const apiCalls = [];
    dispatch(submitStarStatusUpdate(record.recordingId)).then((res) => {
      if (res && res.errors && res.errors[0] && res.errors[0].status === '406') {
        setModalOpen(true);
      } else {
        props.getKardiaRxCCTEcgHistory(props.match.params);
      }
    })
    // .catch((err)=> {
    //   console.log("err", err)
    // });
  }

  // handle change for the set checkbox completed
  const handleChange = (event) => {
    setChecked(event.target.checked);
    let payload;
    payload = {
      is_tech_completed_eos_review : event.target.checked
    }
    props.kardiaRxCctCompletedCheckbox(props.match.params, payload);
  };

    // handle click for the resend eos report
  const handleClickRendEosReport = () => {
    props.kardiaRxCctResendEosReport(props.match.params.idtf_connection_id).then((res) => {
      props.handleDrawerClose()
      if(res[0].errors){
        notification['error']({
                      description: res[0].errors[0].title || res[0].errors[0].detail,       
                  });
      } else {
        notification['success']({
          description: res[0].message,
      });
      }
  })
  }

console.log("eventHistory", props.eventHistory)
  // Alert Modal Close function
  const handleAlertModalClose = () => {
    setModalOpen(false)
  }

  const getTableColumn = () => {
    return [
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="."
              keyMap="highlighter"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'highlighter',
        width: 60,
        key: 'highlighter',
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          let highlightStripState = record.highlightStrip;
          return highlightStripState ? (
            <StarMarkedIcon onClick={(e) =>{ e.stopPropagation(); handleHighlightStrip(e, record)}} />
          ) : (
            <StarUnmarkedIcon onClick={(e) => { e.stopPropagation(); handleHighlightStrip(e, record)}} />
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ACUITY"
              keyMap="acuity"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'acuity',
        key: 'acuity',
        width: 100,
        sorter: (a, b) => a.acuity && a.acuity.localeCompare(b.acuity),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.acuity && `${record.acuity}`;
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {ACUITY_MAP[data]}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ECG ARRIVAL DATE/TIME"
              keyMap="date"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'date',
        key: 'date',
        width: 110,
        sorter: (a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateA - dateB;
        },
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <FormattedDate date={text} />
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="TECH ANALYSIS"
              keyMap="analysis"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'analysis',
        key: 'analysis',
        width: 240,
        sorter: (a, b) =>
          a.analysis && a.analysis.localeCompare(b.analysis),
          onCell: (record, rowIndex) => {
            const highlight = AlertHighlightCell(
             record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
            );
            return {
              style: { ...highlight },
            };
          },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          let data = '';
          if (record.analysis && record.analysis.length) {
            data = printTechIntrString(record.analysis);
          }
          return (
            // <p
            //   style={{
            //     fontWeight: boldText === true ? 'bold' : 'normal',
            //   }}
            // >
            //     {data && data.length >= 50
            //       ? data.substring(0, 49) + '...'
            //       : data}
            // </p>
            <div>
            {
              data && data.length >= 50 ? 
              <LightTooltip title={data}>
              <p
                style={{
                  fontWeight: boldText === true ? 'bold' : 'normal',
                }}
              >
                  {data && data.length >= 50
                    ? data.substring(0, 49) + '...'
                    : data}
              </p>
             </LightTooltip> :  <p
                style={{
                  fontWeight: boldText === true ? 'bold' : 'normal',
                }}
              >
                  {data && data.length >= 50
                    ? data.substring(0, 49) + '...'
                    : data}
              </p>
            }
          </div>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="INCIDENTAL FINDINGS"
              keyMap="incidental_findings"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'incidental_findings',
        key: 'incidental_findings',
        width: 240,
        sorter: (a, b) =>
          a.analysis && a.analysis.localeCompare(b.analysis),
          onCell: (record, rowIndex) => {
            const highlight = AlertHighlightCell(
             record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
            );
            return {
              style: { ...highlight },
            };
          },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          let data = '';
          if (record.incidentalFindings) {
            data = record.incidentalFindings;
          }
          return (
            <div>
              {
                data && data.length >= 50 ? 
                <LightTooltip title={data}>
                <p
                  style={{
                    fontWeight: boldText === true ? 'bold' : 'normal',
                  }}
                >
                    {data && data.length >= 50
                      ? data.substring(0, 49) + '...'
                      : data}
                </p>
               </LightTooltip> :  <p
                  style={{
                    fontWeight: boldText === true ? 'bold' : 'normal',
                  }}
                >
                    {data && data.length >= 50
                      ? data.substring(0, 49) + '...'
                      : data}
                </p>
              }
            </div>
            
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STATUS"
              keyMap="status"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'status',
        key: 'status',
        width: 110,
        sorter: (a, b) =>
          a.status && a.status.localeCompare(b.analysis),
          onCell: (record, rowIndex) => {
            const highlight = AlertHighlightCell(
             record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
            );
            return {
              style: { ...highlight },
            };
          },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          let data = '';
          if (record.inbox) {
            const status = store.getState().annotator.recordingInfo
              .inboxes;
            {
              Object.keys(status).map(item => {
                if (item == record.inbox) {
                  data = status[item];
                }
              });
            }
          }
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="SYMPTOMS"
              keyMap="symptoms"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'symptoms',
        key: 'symptoms',
        width: 240,
        sorter: (a, b) =>
         a.symptoms && a.symptoms.localeCompare(b.symptoms),
          onCell: (record, rowIndex) => {
            const highlight = AlertHighlightCell(
             record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
            );
            return {
              style: { ...highlight },
            };
          },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          let data = '';
          if (record.symptoms) {
            data = record.symptoms.toString();
          }
          return (
            <div>
              {
                data && data.length >= 50 ? 
                <LightTooltip title={data}>
                <p
                  style={{
                    fontWeight: boldText === true ? 'bold' : 'normal',
                  }}
                >
                    {data && data.length >= 50
                      ? data.substring(0, 49) + '...'
                      : data}
                </p>
               </LightTooltip> :  <p
                  style={{
                    fontWeight: boldText === true ? 'bold' : 'normal',
                  }}
                >
                    {data && data.length >= 50
                      ? data.substring(0, 49) + '...'
                      : data}
                </p>
              }
            </div>
            
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ACTIVITY"
              keyMap="activities"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'activities',
        key: 'activities',
        width: 100,
        sorter: (a, b) =>
         a.activities && a.activities.localeCompare(b.activities),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
              CONDITION_COMPARE_TYPE.EQUAL,
              'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.activities && `${record.activities}`;
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="PREVIEW"
              keyMap="preview"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'preview',
        key: 'preview',
        width: 360,
        onCell: () => {
          return {
            style: {    
              position: 'relative',
              padding: 0,
              overflow:'hidden',
              width: "360px",
              height: "77px",
              borderBottom: "0.1px solid #1F356866"
            },
          }
        },
        render: (text, record, index) => {
          const { bpm, previewData, is6l } = record;
          const ekgContent = previewData ? (
            <EKGPreview  height = {150} previewData={previewData} />
          ) : (
            <NoEKGPreview  height = {150}  />
          );

          return (
            <div >
              <div className={styles.ekgPreview}>{ekgContent}</div>
              {is6l && <SixLeadIcon className={styles.sixLIcon} />}
              <div className={styles.tag}>
                <HeartIcon className={styles.heartIcon} />
                <p className={styles.bpm}>
                  {bpm}
                  <span>bpm</span>
                </p>
              </div>
            </div>
          );
        }
      },
    ]
  }

  let  eosReturnObject  = eosReportHelper(props, recordingInfo);


  return (
    <React.Fragment>
      <div className={styles.header}>Patient History</div>
      <AlertModal
        isOpen={isModalOpen}
        style={ALERT_STYLE}
        onClose={() => handleAlertModalClose()}
        alertContent={ALERT_TEXT}
      />

      {((props.KARDIA_RX_CCT_PATIENT_HISTORY &&
        props.KARDIA_RX_CCT_PATIENT_HISTORY.recordings.isFetching)|| props.eventHistory.isFetching) ?
        (<div className={styles.loaderContent}>
          <EcgLoader />
        </div>)
        : (
          <div>
            <div className= {styles.buttonDivCss}>
            <FormGroup style={{ justifyContent: 'flex-end'}} row>
            <div style={{ width: '14%'}}>
            <FormControlLabel
              control={
              <CheckboxCompleted
               color='primary'
              // checked={ (props.eventHistory.data && props.eventHistory.data.length > 0 && props.eventHistory.data[0].event == eventName.checkedCompletedReview)  || (props.eventHistory.data && props.eventHistory.data.length > 0 && props.eventHistory.data[0].event == eventName.requestedReportRefresh )}
               checked = {eosReturnObject.techChkBx.check}
               onChange={handleChange}
               //disabled = {(props.eventHistory.data && props.eventHistory.data.length > 0 && props.eventHistory.data[0].event == eventName.checkedCompletedReview)  || (props.eventHistory.data && props.eventHistory.data.length > 0 && props.eventHistory.data[0].event == eventName.requestedReportRefresh )}
               disabled = {eosReturnObject.techChkBx.disable}
              />            }
              label="Tech Completed EOS Review"
              style={{ marginTop: -11, color: '#000000', fontWeight: '600'}}
            />
            </div>

            <div style={{ width: '12.9%', wordBreak: 'break-word', marginTop: '-8px'}} >{eosReturnObject.textStatus}</div>
            <div style={{ marginTop: '-6px'}}>
              <button
              type="button"
              //className={((props.eventHistory.data && props.eventHistory.data.length > 0 && props.eventHistory.data[0].event == eventName.checkedCompletedReview)  || (props.eventHistory.data && props.eventHistory.data.length > 0 && props.eventHistory.data[0].event == eventName.requestedReportRefresh )) && (moment(todayDate).isAfter(moment( moment(recordingInfo.patient.study_period_starts_at).format("DD-MM-YYYY"), "DD-MM-YYYY").add(recordingInfo.patient.connection_template_duration, 'days'))) ?  `${styles.resendEosReport}`  : `${styles.resendEosReport} ${styles.buttonDisable}` }
              className={eosReturnObject.resEosButton.disable ? `${styles.resendEosReport} ${styles.buttonDisable}` : `${styles.resendEosReport}` }
              data-action="button-cancel-order"
              data-label="Resend Eos Report"
              onClick = {handleClickRendEosReport}
              >
              RESEND EOS REPORT
              </button>
            </div>
            </FormGroup>
            </div>
          <div className={styles.container}>
            <CustomTableComponent
              columns={getTableColumn()}
              data={
                props.KARDIA_RX_CCT_PATIENT_HISTORY &&
                props.KARDIA_RX_CCT_PATIENT_HISTORY.recordings.data[0]
              }
              clickedRow={clickedRow}
              scrollHeight={{ y:  'calc(100vh - 32em)'}}
            />
          </div>
          </div>)
      }
   </React.Fragment>
  );
};

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const KARDIA_RX_CCT_PATIENT_HISTORY = state.kardiaRx.kardiaRxCCTPatientHistory;
  const eventHistory = state.kardiaRx.kardiaRxCCTPatientHistory.eventHistory;
  const eosReportStatus = state.kardiaRx.kardiaRxCCTPatientHistory.eosReportStatus;

  return {
    me,
    KARDIA_RX_CCT_PATIENT_HISTORY,
    eventHistory,
    eosReportStatus,
  };
};

const mapActionCreators = {
  setInitialState: setInitialKardiaRxCCTEcgTableData,
  getKardiaRxCCTEcgHistory: getKardiaRxCCTEcgHistory,
  updateRecordingState: updatedSelectedRxRecording,
  kardiaRxCctResendEosReport,
  getCCTEosEventsHistory,
  kardiaRxCctCompletedCheckbox,
  getEosReportStatus,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(CCTPatientHistory));



// WEBPACK FOOTER //
// ./src/views/components/CCTPatientHistory/CCTPatientHistory.jsx